// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3B3Na","imageUploader":"EGiftCard_imageUploader___VgNU"};